/**
 * useTerm — the component-facing entry point of the Phase-1 terminology
 * service (lib/packs/terminology.ts).
 *
 *   const term = useTerm();
 *   <SkyTitle1>{term("prospect.plural")}</SkyTitle1>   // "Prospects" | "Clients"
 *   `No ${term("referrer.plural").toLowerCase()} yet.` // sentence case at call site
 *
 * Resolution comes from PackContext (PLATFORM_TERMS + installed packs'
 * overrides in install order). Deliberately tolerant of a MISSING
 * provider: reads the context directly (not usePacks(), which throws)
 * and falls back to PLATFORM_TERMS — so the many existing page tests
 * that render CRM pages without a PackProvider keep passing, and any
 * accidental out-of-provider usage degrades to today's labels instead
 * of crashing.
 */

import { useCallback, useContext } from "react";
import { PackContext } from "../components/packs/PackContext";
import { PLATFORM_TERMS, type TermKey } from "../../lib/packs/terminology";

export function useTerm(): (key: TermKey) => string {
  const context = useContext(PackContext);
  const terms = context?.terms ?? PLATFORM_TERMS;
  return useCallback((key: TermKey) => terms[key] ?? PLATFORM_TERMS[key], [terms]);
}
